import(/* webpackMode: "eager" */ "/app/apps/platform-web/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["SidebarAds"] */ "/app/apps/platform-web/components/ads/SidebarAds.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AiBlockedHandler"] */ "/app/apps/platform-web/components/AiBlockedHandler.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthSessionProvider"] */ "/app/apps/platform-web/components/auth/AuthSessionProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CookieConsentBanner"] */ "/app/apps/platform-web/components/consent/CookieConsentBanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ErrorReporter"] */ "/app/apps/platform-web/components/errors/ErrorReporter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FeedbackWidget"] */ "/app/apps/platform-web/components/feedback/FeedbackWidget.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LanguageProvider"] */ "/app/apps/platform-web/components/i18n/LanguageProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ToastProvider"] */ "/app/apps/platform-web/components/toast/ToastProvider.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@next/third-parties/dist/google/ga.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@next/third-parties/dist/google/gtm.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@next/third-parties/dist/ThirdPartyScriptEmbed.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
